import {useCurrentOrPublicUserContext} from "@/components/context/hooks.ts";
import {KPIIconTypes} from "@/components/KPIIcon/KPIIcon.types.ts";
import {SummaryBar} from "@/components/summaryBar/SummaryBar.tsx";
import {SummaryBlock} from "@/components/summaryBar/SummaryBar.types.ts";
import {durationFn, durationSecFn} from "@/lib/format";
import {LatestDowntime} from "@/lib/queries/checks";

interface CheckInfoBoxStats {
  upTime: string;
  outages?: number;
  downTime: string;
  lastDowntimeText: string;
}

type CheckInfoBoxesProps = {
  state: string;
  since: string;
  outages?: number;
  downtimeSecs?: number;
  latestDowntime?: LatestDowntime;
  variant?: "default" | "marketing";
};

export const CheckInfoBoxes = ({
  state,
  since,
  outages,
  downtimeSecs,
  latestDowntime,
  variant = "default",
}: CheckInfoBoxesProps) => {
  const {getShortDateTime} = useCurrentOrPublicUserContext();
  const upTime = state !== "Up" ? "0s" : durationFn(since, undefined, variant === "marketing" ? 2 : undefined);
  const downTime = downtimeSecs ? durationSecFn(downtimeSecs) : "0s";
  const lastDowntimeDuration = latestDowntime ? durationSecFn(latestDowntime.duration) : "";
  const lastDowntimeDate = latestDowntime ? getShortDateTime(latestDowntime!.created_at.toString()) : "";
  const lastDowntimeText = (variant === "default" ? lastDowntimeDate : lastDowntimeDuration) || "None recorded";
  const titleSecondaryText = variant === "default" ? lastDowntimeDuration : "";
  const lastDowntimeTitle = titleSecondaryText ? `Last Downtime: ${titleSecondaryText}` : "Last Downtime";

  const stats: CheckInfoBoxStats = {
    upTime,
    outages,
    downTime,
    lastDowntimeText,
  };
  const summaryBlocks: SummaryBlock<CheckInfoBoxStats>[] = [
    {
      title: "Up for",
      icon: KPIIconTypes.CHECKS_UP,
      renderStat: ({upTime}) => <>{upTime}</>,
    },
    {
      title: "Alerts",
      icon: KPIIconTypes.ALERTS_ACTIVE,
      renderStat: ({outages}) => <>{outages ?? ""}</>,
    },
    {
      title: "Downtime",
      icon: KPIIconTypes.CHECKS_DOWN,
      renderStat: ({downTime}) => <>{downTime}</>,
    },
    {
      title: lastDowntimeTitle,
      icon: KPIIconTypes.ALERTS_LAST,
      renderStat: ({lastDowntimeText}) => <>{lastDowntimeText}</>,
    },
  ];

  return (
    <SummaryBar
      stats={stats}
      summaryBlocks={summaryBlocks}
      columns={{
        sm: 1,
        md: 2,
        lg: 2,
        xl: 2,
      }}
    />
  );
};
